
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandB as ObiOwnShipNoCommandBElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-b.js';
 
 
 

 
 export const ObiOwnShipNoCommandB = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-b',
   elementClass: ObiOwnShipNoCommandBElement,
   events: {
     
   }
  });
 
 